// src/hooks/cities/useForceDeleteAllCities.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllCities } from "../../api/apiCities";
import parseError from "../../utils/parseError";

const useForceDeleteAllCities = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAllCitiesMutate, isPending } = useMutation({
        mutationFn: forceDeleteAllCities,
        onSuccess: (res) => {
            const message = res?.message || "Cities force deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["cities"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to force delete cities");
        },
    });

    return { forceDeleteAllCitiesMutate, isPending };
};

export default useForceDeleteAllCities;